import { render, staticRenderFns } from "./menuPop.vue?vue&type=template&id=5073c2d2&scoped=true"
import script from "./menuPop.vue?vue&type=script&lang=js"
export * from "./menuPop.vue?vue&type=script&lang=js"
import style0 from "./menuPop.vue?vue&type=style&index=0&id=5073c2d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5073c2d2",
  null
  
)

export default component.exports